var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimesheetIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.678,
    height: 24.678,
    viewBox: "0 0 24.678 24.678",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1895",
    "data-name": "Group 1895",
    transform: "translate(-8332 -8171)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18",
    "data-name": "Ellipse 18",
    cx: 12.339,
    cy: 12.339,
    r: 12.339,
    transform: "translate(8332 8171)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "time-management",
    transform: "translate(5988.39 7928.99)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4071",
    "data-name": "Path 4071",
    d: "M2358.33,253.555a3.571,3.571,0,1,0,3.571,3.571A3.571,3.571,0,0,0,2358.33,253.555Zm0,.794a2.778,2.778,0,1,1-2.778,2.777,2.778,2.778,0,0,1,2.778-2.777Zm1.19-1.515v-2.056a2.778,2.778,0,0,0-2.778-2.778h-3.968a2.778,2.778,0,0,0-2.778,2.778v6.349a2.778,2.778,0,0,0,2.778,2.778h1.9a.4.4,0,1,0,0-.794h-1.9a1.984,1.984,0,0,1-1.984-1.984v-6.349a1.984,1.984,0,0,1,1.984-1.984h3.968a1.984,1.984,0,0,1,1.984,1.984v2.056a.4.4,0,0,0,.794,0Zm.2,3.9h-.992v-1.587a.4.4,0,1,0-.793,0v1.984a.4.4,0,0,0,.4.4h1.389a.4.4,0,1,0,0-.794Zm-7.142-.794h1.686a.4.4,0,0,0,0-.794h-1.686a.4.4,0,0,0,0,.794Zm0-1.587h2.76a.4.4,0,0,0,0-.794h-2.76a.4.4,0,0,0,0,.794Zm0-1.587h4.365a.4.4,0,1,0,0-.794h-4.365a.4.4,0,0,0,0,.794Z",
    fill: "#00aaf6",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimesheetIcon);
export default __webpack_public_path__ + "static/media/timesheetIcon.950ffea14de146ee22f4d240b3362236.svg";
export { ForwardRef as ReactComponent };